export default {
  categories: state => state.categories,
  categoryId: state => id => state.categories.filter(category => category.id == id)[0],
  category: state => state.category,
}